export default "__VITE_ASSET__a3e3a45b__"